import React, { useState } from "react";
import {
  loginAction,
  loginActionStart,
} from "../../redux/actions/LoginActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import img from "../../img/newLogin.jpg";
import ForgetPassword from "../Forget-Password/ForgetPassword";
import "./login.scss";
//import { LOGIN_START } from '../redux/actionsTypes/Types';
import * as Yup from "yup";
import { LOGIN_START } from "../../redux/actionsTypes/Types";
import { Form, Formik } from "formik";
import FormikControl from "../formikcontrols";
import { emailRegex, passwordRegex } from "../../utils/validation";
import { Button } from "react-bootstrap";
const Login = ({ setIsAuthen }) => {
  const [loginDetails, setLoginDetails] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const { isLogin, isError } = useSelector((state) => state?.login);
  const navigate = useNavigate();
  const [passwordType, setPasswordType] = useState("password");
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginDetails({ ...loginDetails, [name]: value });
  };

  var validationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(emailRegex, "You have entered an invalid email address!")
      .required("Email is Required")
      .nullable(),
    password: Yup.string()
      .matches(
        passwordRegex,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      )
      .required("Password is Required")
      .nullable(),
  });

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const handleSubmit = (e) => {
    let loginDetails = { ...e };
    //e.preventDefault()
    //  e.preventDefault()
    let payload = {
      loginDetails,
      navigate,
    };
    dispatch(loginAction(LOGIN_START, payload));
  };

  return (
    <div className="Login">
      <div className="Login_firstHalf">
        <div className="form">
          <Formik
            initialValues={{
              email: "",
              password: "",
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <Form>
              <div className="Login_firstHalf-loginForm">
                <div className="img"></div>

                <div className="flex">
                  <FormikControl
                    control="input"
                    type="email"
                    name="email"
                    placeholder="Enter Email"
                    label="Email"
                    className="input"
                  />
                </div>
                <div className="flex">
                  <FormikControl
                    control="input"
                    type={passwordType}
                    label="Password"
                    name="password"
                    placeholder="Enter Password"
                    className="input"
                  />
                  <span
                    className="icon_showpass"
                    onClick={togglePassword}
                    style={{ cursor: "pointer" }}
                  >
                    {passwordType === "password" ? (
                      <i className="bi bi-eye-slash"></i>
                    ) : (
                      <i className="bi bi-eye"></i>
                    )}
                  </span>
                </div>

                <div className="forget">
                  <input
                    className="checkbox"
                    style={{ margin: "0" }}
                    type="checkbox"
                    name=""
                    id=""
                  />
                  <span>Remember Me</span>
                  <span style={{ display: "grid", justifySelf: "end" }}>
                    <Link to="/forgetpassword">Forget Password?</Link>
                  </span>
                </div>
                <div>{error}</div>
                <Button className="login_btn" type="submit">
                  {" "}
                  {isLogin ? "Please Wait...!" : "Sign In"}
                </Button>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
      <div className="Login_secondhalf">
        {/* <div className='Login_secondhalf-img'></div> */}
        <img className="Login_secondhalf--img" src={img} alt="img" />
      </div>
    </div>
  );
};

export default Login;
